module.exports = {
      id: "arrow-shaded-usage",
      viewBox: "0 0 13 25",
      url: __webpack_public_path__ + "assets/img/sprite-6589e8.svg#arrow-shaded-usage",
      toString: function () {
        return this.url;
      }
    }